import React, { useEffect } from 'react'
import QueryString from 'query-string'
import routes from './routeInfo'
import { Route, Redirect, useLocation, Switch } from 'react-router-dom'
import { setFeatureFlag } from '../utils/featureFlag'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const params = new URLSearchParams(props.location.search)

      const passwordToken = params.get('password_reset_token')
      const isOnboarding = params.get('on_board') == "true"


      if (rest.isAuth || passwordToken) {
        return <Component {...props} {...rest} />
      }

      return (
        <Redirect
          to={{
            pathname: '/login',
            state: {
              from: {
                ...props.location,
                state: {
                  ...(props.location.state || {}),
                  onBoard: isOnboarding || false,
                },
              },
            },
          }}
        />
      )
    }}
  />
)

export const BuildRoutes = ({ isMobile, isAuth, auth }) => {
  const location = useLocation()

  useEffect(() => {
    const queryParams = QueryString.parse(location.search)
    setFeatureFlag(queryParams)
  }, [location])

  return (
    <React.Fragment>
      <Switch>
        {routes.map(
          ({ path, component: Component, is_private, is_mother }, key) =>
            !is_private ? (
              <Route
                exact={is_mother ? false : true}
                path={path}
                key={key}
                render={(props) => (
                  <Component
                    {...props}
                    isMobile={isMobile}
                    isAuth={isAuth}
                    auth={auth}
                  />
                )}
              />
            ) : (
              <PrivateRoute
                isAuth={isAuth}
                isMobile={isMobile}
                auth={auth}
                exact={is_mother ? false : true}
                path={path}
                key={key}
                component={Component}
              />
            )
        )}
      </Switch>
    </React.Fragment>
  )
}

export default BuildRoutes
